export enum Parameter {
  'disable-stt' = 'disable-stt',
  'show-learn-more' = 'show-learn-more',
  'brand' = 'brand',
  'disable-compare' = 'disable-compare',
  'custom-cta-label' = 'custom-cta-label',
  'custom-cta-href' = 'custom-cta-href',
  'custom-cta-aria-label' = 'custom-cta-aria-label',
}

export type ParameterCode = keyof typeof Parameter;
